<epay-page-content [pagetitle]="pagetitle">
  <div class="container">
    <div class="shadow max-w max-gs" id="page-content-main">
      <mat-card class="" style="border-radius: 10px">
        <mat-card-content>
          <h4 style="color: rgb(92, 92, 92); margin-left: 1vw">Helpful Links</h4>

          <div class="accordion-flush" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <h3>Noncustodial Parent Links</h3>
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="mb-5 mt-3">
                    <h2 class="h3 mb-1 panel-default">Contact Us</h2>
                    <p>
                      <a routerLink="/contact">
                        Visit our Contact Us page
                        <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                      </a>
                    </p>
                  </div>
                  <div class="mb-5">
                    <h2 class="h3 mb-1">FAQs</h2>
                    <p>
                      <a routerLink="/faq">
                        Browse Frequently Asked Questions
                        <i class="fa fa-question-circle ms-1" aria-hidden="true"></i>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</epay-page-content>
